import {
  Inject,
  Injectable,
  Optional,
  RendererFactory2,
  DOCUMENT
} from '@angular/core';

import { RestActivityHandlerService } from '../rest/rest-activity-handler.service';
import { ACTIVITY_INDICATOR_CONFIGURATION } from './activity-indicator.domain';
import type {
  OnDestroy,
  Renderer2 } from '@angular/core';

import type { Subscription } from 'rxjs';

import type { PostBootstrapInit } from '../post-bootstrap-init';
import type { ActivityIndicatorConfiguration } from './activity-indicator.domain';

@Injectable({
  providedIn: 'root'
})
export class ActivityIndicatorService implements OnDestroy, PostBootstrapInit {
  private static readonly ANIMATION_REMOVE_DELAY: number = 500;

  private readonly loadIndicatorClass: string = 'td-wb-loading-bar';
  private readonly cursorClass: string = 'td-wb-cursor-busy';

  private renderer: Renderer2;
  private subscription: Subscription;
  private timer: NodeJS.Timeout;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(RendererFactory2) rendererFactory: RendererFactory2,
    @Optional() @Inject(ACTIVITY_INDICATOR_CONFIGURATION)
    activityIndicatorConfiguration: ActivityIndicatorConfiguration,
    @Inject(RestActivityHandlerService) private readonly restActivityHandlerService: RestActivityHandlerService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    if (activityIndicatorConfiguration !== null) {
      this.loadIndicatorClass = activityIndicatorConfiguration.loadIndicatorClass;
      this.cursorClass = activityIndicatorConfiguration.cursorClass;
    }
  }

  init(): void {
    this.subscription =
      this.restActivityHandlerService.onRequestCountChange.subscribe((value: boolean): void => {
        this.clearTimeout();
        if (value) {
          this.addClass(this.cursorClass);
          this.addClass(this.loadIndicatorClass);
        } else {
          this.timer = setTimeout((): void => {
            this.removeClass(this.cursorClass);
            this.removeClass(this.loadIndicatorClass);
          }, ActivityIndicatorService.ANIMATION_REMOVE_DELAY);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.clearTimeout();
  }

  private addClass(className: string): void {
    this.renderer.addClass(this.document.body, className);
  }

  private removeClass(className: string): void {
    this.renderer.removeClass(this.document.body, className);
  }

  private clearTimeout(): void {
    if (this.timer !== undefined) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }

}
